<!--
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2021-12-30 15:24:34
 * @LastEditors: mojiangpeng 125392435@qq.com
 * @LastEditTime: 2022-05-25 15:54:42
-->
<template>
  <div class="container">
    <head-nav-bar title="核酸检测开单" :fixed="true" />
    <div class="mt-header-nav" style="paddingTop:1px">
      <van-cell-group>
        <van-cell title="检测人" :value="info.cardholderName" />
        <van-cell title="就诊卡" :value="info.cardNo" />
        <van-cell title="证件号" :value="info.identityDocNoProcted" />
        <van-cell
          title="电话号码"
          :value="info.cardholderContactPhoneProcted"
        />
      </van-cell-group>
      <div class="header-box">
        <div>检测项目</div>
        <div>单位（元）</div>
      </div>

      <van-radio-group v-model="applyPackageValue">
        <van-cell-group>
          <van-cell
            v-for="item in applyPackageList"
            :key="item.subAdviceId"
            clickable
            @click="applyPackageValue = item.subAdviceId"
          >
            <div slot="title" style="padding-left:10px">
              <b>{{ item.itemName }}</b>
            </div>
            <template #icon>
              <van-radio :name="item.subAdviceId" />
            </template>
            <template #right-icon>
              <span>￥{{ item.unitPrice }}</span>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <van-button @click="onSubmit" type="info" class="submit"
      >开单申请</van-button
    >
    <form ref="form" method="post" name="auto_submit_form" :action="payAction">
      <input
        v-for="item in payParams"
        :key="item.Key"
        type="hidden"
        :name="item.key"
        :value="item.value || ' '"
      />
      <input
        type="submit"
        value="立刻提交"
        style="display:none"
        name="name"
        id="name"
      />
    </form>
    <action-sheet v-model="show" :actions="payMethod" @select="onSelect" />
  </div>
</template>

<script>
import {
  Cell,
  CellGroup,
  Button,
  Col,
  Row,
  Checkbox,
  Notify,
  Dialog,
  Radio,
  RadioGroup,
  Toast,
  ActionSheet,
} from "vant"

import wx from "weixin-jsapi"
import urls from "@/api/url"

export default {
  components: {
    // DataList,
    ActionSheet,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Col.name]: Col,
    [Row.name]: Row,
    [Checkbox.name]: Checkbox,
    [Dialog.Component.name]: Dialog.Component,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
  },
  data() {
    return {
      show: false,
      info: {},
      applyPackageList: [],
      checked: true,
      clickFlag: true,
      applyPackageValue: "",
      payMethod: [],
      payParams: [],
      payWechatData: {},
      payAction: "",
      settingList: {},
    }
  },
  created() {
    this.params = this.$route.query
    console.log(this.params)
    if (this.params && this.params.id) {
      this.$post("Contact_Info", { Id: this.params.id }).then((res) => {
        this.info = res.data
      })
    }

    let json = {
      ourHospital: this.params.ourHospital == 1,
    }
    if (json.ourHospital) {
      json.identityNo = this.params.identityDocNo
    }

    this.$post("GetApplyPackageInfo", json)
      .then((res) => {
        let list = []
        for (let i = 0; i < res.data.length; i++) {
          const item = res.data[i]
          if (item.itemList) {
            for (let j = 0; j < item.itemList.length; j++) {
              const p = item.itemList[j]
              if (json.ourHospital || p.unitPrice > 0) {
                list.push({
                  ...p,
                  subAdviceId: item.subAdviceId,
                })
              }
            }
          }
        }
        this.applyPackageList = list
        if (list.length === 1) {
          this.applyPackageValue = list[0].subAdviceId
        }
      })
      .catch(() => {
        if (json.ourHospital) {
          // 非本院员工
          this.$router.go(-1)
        }
      })
    this.$post("Common_SelectData", { Code: "MobilePayMethodDic" }).then(
      (res) => {
        res.data.MobilePayMethodDic.map((item) => {
          this.payMethod.push({
            name: item.text,
            ...item,
          })
        })
      }
    )
  },
  methods: {
    onSubmit() {
      this.checkApplyPackage()
    },
    checkNeedToScreeningForm() {
      if (!this.clickFlag) return
      this.clickFlag = false
      const _this = this
      //先判断需要填筛查表吗？
      _this
        .$post("GetScreeningForm_InfoAsync", { EpidemicType: 1 })
        .then((res) => {
          _this.screeningFormData = res.data
          if (res.data == null) {
            //不需要填筛查表
            _this.chooseBtn()
          } else {
            //需要填筛查表
            //判断该就诊人今天有没有填写筛查表
            _this
              .$post("GetScreeningForm_RecordInfo", {
                DiagnoseCardNo: _this.info.diagnosisCardNo,
              })
              .then((res) => {
                if (res.data.length > 0) {
                  //今天填了筛查表
                  _this.chooseBtn()
                } else {
                  // 今天没有填筛查表
                  Dialog.confirm({
                    title: "提示",
                    message: `请先填写《${_this.screeningFormData.Name}》`,
                  })
                    .then(() => {
                      _this.$router.push({
                        name: "screeningFormForm",
                        query: {
                          contactId: _this.info.id,
                          callbackUrl: "nucleinBill",
                        },
                      })
                    })
                    .catch(() => {
                      _this.submitLoading = false
                    })
                  this.clickFlag = true
                  return false
                }
              })
          }
        })
    },
    checkApplyPackage() {
      if (!this.applyPackageValue) {
        Toast.fail("请勾选检测项目")
        return
      }
      this.clickFlag = true
      const applyPackage = this.applyPackageList.find(
        (p) => p.subAdviceId === this.applyPackageValue
      )
      if (applyPackage && applyPackage.alarmRemark) {
        const date = new Date()
        const hour = date.getHours()
        const minut = date.getMinutes()
        if (hour > 8 && (hour < 17 || (hour == 17 && minut < 30))) {
          Dialog.confirm({
            title: "提示",
            message: applyPackage.alarmRemark,
          })
            .then(() => {
              this.checkNeedToScreeningForm()
            })
            .catch(() => {})
        } else {
          Dialog.alert({
            title: "提示",
            message: "检查时间为8:00—17:30，请在该时间段内操作",
          })
            .then(() => {})
            .catch(() => {})
        }
      } else {
        this.checkNeedToScreeningForm()
      }
    },
    chooseBtn(reapply) {
      const that = this
      const applyPackage = that.applyPackageList.find(
        (p) => p.subAdviceId === that.applyPackageValue
      )
      const params = {
        PatientName: that.info.cardholderName,
        Sex: that.info.cardholderSex + "",
        Birthday: that.info.cardholderBirthDate,
        Age: that.info.age,
        DiagnosisCardNo: that.info.diagnosisCardNo,
        Address: that.info.cardholderContactAddress,
        IdentityNo: that.info.identityDocNo,
        ContactPhone: that.info.cardholderContactPhone,
        SubAdviceId: that.applyPackageValue,
        AlarmRemark: applyPackage.alarmRemark,
        reapply: reapply,
      }
      that
        .$post("NewOutpatientInfo", params)
        .then((res) => {
          if (this.params.ourHospital == 1) {
            // 本院员工直接调支付
            this.ourHospitalPay(res.data)
          } else if (
            res.data.outpatientLogId &&
            res.data.doctorId &&
            res.data.departmentId &&
            res.data.visitDate
          ) {
            that.payWechatData = {
              outpatientLogId: res.data.outpatientLogId,
              doctorId: res.data.doctorId,
              departmentId: res.data.departmentId,
              visitDate: res.data.visitDate,
            }
            that.toPay()
          }
        })
        .catch((err) => {
          if (err.data.message == "EXIST") {
            that.$router.push({
              name: "userBill",
              query: { ...that.params },
            })
          } else if (err.data.message == "EXISTCHARGED") {
            Dialog.confirm({
              message:
                "【" +
                that.params.cardholderName +
                "】：【" +
                that.params.diagnosisCardNo +
                "】" +
                "今日存在已支付的自助申请检查，是否再次申请！",
            })
              .then(() => {
                that.chooseBtn(true)
              })
              .catch(() => {
                that.$router.push({
                  name: "userBill",
                  query: { ...that.params, tab: 1 },
                })
              })
          }
        })
        .finally(() => {
          setTimeout(() => {
            that.clickFlag = true
          }, 2000)
        })
    },
    // 本院员工支付
    ourHospitalPay(data) {
      this.loading = true
      this.$post(this.$config.payUrl + urls.HospitalOutpatientPay, {
        diagnosisCardNo: this.info.diagnosisCardNo,
        outpatientLogId: data.outpatientLogId,
        applyRecipeId: data.applyRecipeId,
      })
        .then(() => {
          this.loading = false
          Notify({ background: "rgb(7,193,96)", message: "开单成功" })
          this.$router.push({
            name: "userBill",
            query: { tab: 1 },
          })
        })
        .catch(() => {
          this.loading = false
        })
    },
    toPay() {
      if (this.payMethod.length == 1) {
        this.onSelect(this.payMethod[0])
      } else {
        this.show = true
        return
      }
      this.loading = true
    },
    onSelect(item) {
      this.show = false
      delete item.id
      this.$post("Pay_Wechat", {
        Id: this.payWechatData.outpatientLogId,
        PayType: "2",
        DoctorId: this.payWechatData.doctorId,
        DepartmentId: this.payWechatData.departmentId,
        VisitDate: this.payWechatData.visitDate,
        DiagnosisCardNo: this.info.diagnosisCardNo,
        OutTradeNo: Date.now() + "",
        payMethod: item.value,
      }).then((res) => {
        this.loading = false
        this.setWxConfig(res.data)
      })
    },
    // toPay(OutpatientLogId, DoctorId, DepartmentId, VisitDate) {
    //   this.loading = true;
    //   this.$post("Pay_Wechat", {
    //     Id: OutpatientLogId,
    //     PayType: 2,
    //     DoctorId: DoctorId,
    //     DepartmentId: DepartmentId,
    //     VisitDate: VisitDate,
    //     DiagnosisCardNo: this.info.diagnosisCardNo
    //   }).then(res => {
    //     this.loading = false;
    //     this.setWxConfig(res.data);
    //   });
    // },
    setWxConfig(option) {
      const that = this
      if (option.apiUrl) {
        this.payAction = option.apiUrl
        this.payParams = option.params.map((item) => {
          item.value.replace('"', "&quot;")
          return item
        })
        this.$nextTick(() => {
          this.$refs.form.submit()
        })
      } else {
        wx.config({
          debug: false, //这里一般在测试阶段先用true，等打包给后台的时候就改回false,
          appId: option.appId,
          timestamp: option.timeStamp,
          nonceStr: option.nonceStr,
          signature: option.paySign,
          jsApiList: ["chooseWXPay"],
        })
        wx.ready(function() {
          wx.checkJsApi({
            jsApiList: ["chooseWXPay"],
            success: function(res) {
              console.log(res, "seccess")
            },
            fail: function(res) {
              console.log(res, "fail")
            },
          })
          that.jsApiCall(option)
        })
      }
    },
    jsApiCall(option) {
      const _this = this
      wx.ready(function() {
        wx.chooseWXPay({
          appId: option.appId,
          timestamp: option.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: option.nonceStr, // 支付签名随机串，不长于 32
          package: option.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: "MD5", // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: option.paySign, // 支付签名
          success: function(res) {
            console.log(res)
            //跳转到支付成功页面有这个页面
            // _this.getInfo();
            Notify({ background: "rgb(7,193,96)", message: "支付成功" })
            _this.$router.push({
              name: "userBill",
            })
          },
          cancel: function(res) {
            console.log(res)
            //取消支付
            // _this.$router.push({
            //   name: "servePreOrderResult",
            //   query: { Id: _this.Id }
            // });
          },
          fail: function(res) {
            console.log(res)
            alert("支付失败，请重试")
          },
        })
      })
    },
    // toPay(OutpatientLogId, DoctorId, DepartmentId, VisitDate) {
    //   this.loading = true;
    //   this.$post("Pay_Wechat", {
    //     Id: OutpatientLogId,
    //     PayType: 2,
    //     DoctorId: DoctorId,
    //     DepartmentId: DepartmentId,
    //     VisitDate: VisitDate,
    //     DiagnosisCardNo: this.info.diagnosisCardNo
    //   }).then(res => {
    //     this.loading = false;
    //     this.setWxConfig(res.data);
    //   });
    // },
    // setWxConfig(option) {
    //   const that = this;
    //   wx.config({
    //     debug: false, //这里一般在测试阶段先用ture，等打包给后台的时候就改回false,
    //     appId: option.appId,
    //     timestamp: option.timeStamp,
    //     nonceStr: option.nonceStr,
    //     signature: option.paySign,
    //     jsApiList: ["chooseWXPay"]
    //   });
    //   wx.ready(function() {
    //     wx.checkJsApi({
    //       jsApiList: ["chooseWXPay"],
    //       success: function(res) {
    //         console.log("seccess");
    //       },
    //       fail: function(res) {
    //         console.log("fail");
    //         console.log(res);
    //       }
    //     });
    //     that.jsApiCall(option);
    //   });
    // },
    // jsApiCall(option) {
    //   const _this = this;
    //   wx.ready(function() {
    //     // alert(JSON.stringify(json));
    //     wx.chooseWXPay({
    //       appId: option.appId,
    //       timestamp: option.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
    //       nonceStr: option.nonceStr, // 支付签名随机串，不长于 32
    //       package: option.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
    //       signType: "MD5", // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
    //       paySign: option.paySign, // 支付签名
    //       success: function(res) {
    //         //跳转到支付成功页面有这个页面
    //         // console.log("支付成功", res);
    //         // _this.getInfo();
    //         Notify({ background: "rgb(7,193,96)", message: "支付成功" });
    //         _this.$router.push({
    //           name: "userBill"
    //         });
    //       },
    //       cancel: function(res) {
    //         //取消支付
    //         // _this.$router.push({
    //         //   name: "servePreOrderResult",
    //         //   query: { Id: _this.Id }
    //         // });
    //       },
    //       fail: function(res) {
    //         alert("支付失败，请重试");
    //       }
    //     });
    //   });
    // }
  },
}
</script>

<style lang="less" scoped>
.header-box {
  font-size: 12px;
  color: rgb(147, 147, 147);
  display: flex;
  padding: 10px;
  justify-content: space-between;
  background-color: rgb(244, 244, 244);
}

.submit {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  padding: 10px;
  background-color: #fff;
  border-radius: 20px;
}
</style>
